export const APP_VERSION_URL = "/version.json";
export const APP_VERSION_POLL_MS = 60_000;

export function parseAppVersionId(payload: unknown): string | null {
  if (!payload || typeof payload !== "object") return null;
  const id = (payload as { id?: unknown }).id;
  if (typeof id !== "string") return null;
  const trimmed = id.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/** Build id stamped into this JS bundle at compile time. */
export function runningAppBuildId(
  envBuildId: unknown = import.meta.env.VITE_APP_BUILD_ID,
): string | null {
  if (typeof envBuildId !== "string") return null;
  const trimmed = envBuildId.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function shouldPromptNewVersion(
  currentId: string | null,
  remoteId: string | null,
): boolean {
  if (!currentId || !remoteId) return false;
  return currentId !== remoteId;
}
